import GiftCardsCard from './GiftCardsCard';

export default GiftCardsCard;
